import {
  computeSpaceFit,
  computeMarketSpaceFit,
  SPACE_FIT_VERDICT_OVER,
  SPACE_FIT_VERDICT_TIGHT,
  SPACE_FIT_VERDICT_DENSE,
  SPACE_FIT_VERDICT_RIGHT,
  SPACE_FIT_VERDICT_UNDER,
} from "../../utils/spaceFitVerdict.js";

export const REGION_CAPACITY_BUCKETS = [
  { key: "over", label: SPACE_FIT_VERDICT_OVER, verdict: SPACE_FIT_VERDICT_OVER },
  { key: "near", label: SPACE_FIT_VERDICT_TIGHT, verdict: SPACE_FIT_VERDICT_TIGHT },
  { key: "rightSized", label: SPACE_FIT_VERDICT_RIGHT, verdict: SPACE_FIT_VERDICT_RIGHT },
  { key: "room", label: SPACE_FIT_VERDICT_UNDER, verdict: SPACE_FIT_VERDICT_UNDER },
  { key: "noData", label: "no data", verdict: null },
];

const BUCKET_BY_VERDICT = new Map(
  REGION_CAPACITY_BUCKETS.filter((bucket) => bucket.verdict != null)
    .map((bucket) => [bucket.verdict, bucket.key]),
);

function emptyCounts() {
  return Object.fromEntries(REGION_CAPACITY_BUCKETS.map(({ key }) => [key, 0]));
}

/**
 * Count markets into Region view capacity buckets using the same canonical
 * per-market Space Fit verdict shown in Market view.
 */
export function getRegionCapacityBuckets(markets) {
  const byRegion = new Map();
  const total = emptyCounts();

  for (const market of markets ?? []) {
    const region = market.region ?? "No region";
    if (!byRegion.has(region)) byRegion.set(region, emptyCounts());

    const { verdict } = computeMarketSpaceFit(market);
    const key = BUCKET_BY_VERDICT.get(verdict) ?? "noData";
    byRegion.get(region)[key] += 1;
    total[key] += 1;
  }

  return { byRegion, total };
}
